module.exports = __webpack_public_path__ + "img/cs-iosclub-2.2e095733.jpg";